import { gql } from "@apollo/client"

const GET_STAFF_SCHEDULE_XLS_DOWNLOAD_LINK = gql`
  query staffScheduleXlsDownload($input: StaffScheduleXlsDownloadInput!) {
    staffScheduleXlsDownload(input: $input) {
      filename
      url
      type
      queued
    }
  }
`

export { GET_STAFF_SCHEDULE_XLS_DOWNLOAD_LINK }